var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.96 1-7.02 9.66L6 24.94 15.96 31l9.96-6.06-3-14.34L15.96 1zM7.62 24.28l2.22-10.86 5.04 15.3-7.26-4.44zm2.94-13.32 5.4-7.44 5.4 7.44-5.4 16.32-5.4-16.32zm6.42 17.76 5.04-15.3 2.22 10.86-7.26 4.44z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEos);
export default __webpack_public_path__ + "static/media/EOS.a03dd2835f190f70e8f1634981d4929b.svg";
export { ForwardRef as ReactComponent };